import { useMemo } from 'react';

import { isFbkApp, isPosty, isZigzag } from '@common/device-manager';

import { createFbkSender } from './senders/fbkSender';
import { createPostySender } from './senders/postySender';
import { UBLSender } from './senders/types';
import { createWebSender } from './senders/webSender';
import { createZigzagSender } from './senders/zigzagSender';
import { Tracker, useTracker } from './Tracker';

function createSenderByPlatform(tracker: Tracker): UBLSender {
  if (isZigzag()) {
    return createZigzagSender(tracker);
  }
  if (isPosty()) {
    return createPostySender(tracker);
  }
  if (isFbkApp()) {
    return createFbkSender(tracker);
  }
  return createWebSender(tracker);
}

/**
 * @deprecated useUBL() 직접 사용하도록 마이그레이션 해주세요.
 * 사용처: ten-million-tf, event/detail
 */
export function getUblSender({ tracker }: { tracker: Tracker }) {
  return createSenderByPlatform(tracker);
}

export function useUBL() {
  const tracker = useTracker();
  return useMemo(() => createSenderByPlatform(tracker), [tracker]);
}
